export default "__VITE_ASSET__be34cf20__"